import { useId } from 'react';
import type { ReactElement, ReactNode } from 'react';

export interface SectionProps {
  readonly title: string;
  readonly hint?: string;
  readonly actions?: ReactNode;
  readonly tone?: 'default' | 'danger';
  readonly children: ReactNode;
}

/**
 * The one and only card level. Sections are never nested inside each other —
 * the spec forbids cards-in-cards, and a flat surface is far easier to scan
 * on a 390px screen.
 */
export function Section({
  title,
  hint,
  actions,
  tone = 'default',
  children,
}: SectionProps): ReactElement {
  const headingId = useId();
  return (
    <section
      className={tone === 'danger' ? 'section section--danger' : 'section'}
      aria-labelledby={headingId}
    >
      <div className="section__head">
        <h2 className="section__title" id={headingId}>
          {title}
        </h2>
        {actions !== undefined && <div className="row">{actions}</div>}
      </div>
      {hint !== undefined && (
        <p className="section__hint" style={{ marginBottom: 'var(--s-3)' }}>
          {hint}
        </p>
      )}
      {children}
    </section>
  );
}
